<h2 mat-dialog-title>Select Image</h2>

<mat-dialog-content>
  Select or upload a new image below
  <br /><br />
  <div class="image-grid">
    <div
      *ngFor="let image of images"
      class="image-tile"
      [class.selected]="selectedImageId === image.id"
      (click)="onSelectImage(image)"
    >
      <img [src]="image.image" [alt]="'Template image ' + image.id" />
      <div class="lock-overlay" *ngIf="isImageUsedInTemplate(image.id)">
        <mat-icon>lock</mat-icon>
      </div>
    </div>

    <div class="image-tile upload-tile" (click)="fileInput.click()">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>
      <span>Upload new</span>
      <input #fileInput type="file" accept="image/*" hidden (change)="onFileInputChange($event)" />
      <mat-error *ngIf="uploadError">{{ uploadError }}</mat-error>
    </div>

    <div *ngIf="data.canHideImage" class="image-tile hide-tile" (click)="onHideImage()">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
      </svg>
      <span>Hide from report</span>
    </div>

    <div *ngIf="data.canHideImage" class="image-tile default-tile" (click)="onUseDefault()">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
        <path
          d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
        />
      </svg>
      <span>Use default</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onClear()" matTooltip="Removes the image from this placeholder">Remove image</button>
  <span class="spacer"></span>
  <button
    mat-button
    color="warn"
    *ngIf="selectedImageIsDeleteable"
    (click)="onDeleteImage()"
    matTooltip="Deletes this image from the template"
  >
    Delete
  </button>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!selectedImageId" (click)="onConfirm()">Select</button>
</mat-dialog-actions>
